export const API_EMAIL = {
  DEFAULT_API_URL: '/bo/email_v2/',
  DEFAULT_TOKEN: 'ItEHjYrSgkRmfKX5YIEwcEoNFITB87cp',
}

export const API_EMAIL_BO_API = {
  DEFAULT_API_URL: '/api/lpe/',
  DEFAULT_TOKEN: 'Xd426dghyreZF323545TGC3VRdfz',
  EMAIL_DATA: 'email_data.php',
}
